export const ADD_FOODS_TO_CATEGORY_GROUP = "ADD_FOODS_TO_CATEGORY_GROUP"
export const ADD_FOOD_TO_CATEGORY_GROUP = "ADD_FOOD_TO_CATEGORY_GROUP"
export const UPDATE_FOODS_IN_CATEGORY_GROUP = "UPDATE_FOODS_IN_CATEGORY_GROUP"
export const REMOVE_FOODS_FROM_CATEGORY_GROUP = "REMOVE_FOODS_FROM_CATEGORY_GROUP"
export const REPLACE_FOOD_IDS_IN_CATEGORY_GROUP = "REPLACE_FOOD_IDS_IN_CATEGORY_GROUP"
export const ADD_FOOD_CATEGORY_GROUP = "ADD_FOOD_CATEGORY_GROUP"
export const UPDATE_FOOD_CATEGORY_GROUP = "UPDATE_FOOD_CATEGORY_GROUP"
export const DELETE_FOOD_CATEGORY_GROUPED = "DELETE_FOOD_CATEGORY_GROUPED"
export const CLEAR_FOOD_CATEGORIES_GROUPS = "CLEAR_FOOD_CATEGORIES_GROUPS"